import React from 'react';

import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { SanitizeMode, useSanitizedText } from 'util/sanitized';

export const SnowReportComments = ({ comments }: { comments: string, isFresh: boolean }) => {
  const { t } = useOTSTranslation('common');
  const cleanComments = useSanitizedText(comments, SanitizeMode.Partial);

  return (
    <BoxWithShadow>
      <BlockHeader title={t('resort.skiReport.SnowreporterComments')} />
      <BlockContent>
        <div dangerouslySetInnerHTML={{ __html: cleanComments }} />
      </BlockContent>
    </BoxWithShadow>
  );
};
